import React from "react";
import i18n from "i18next";

export default function TopBar({ tabs, activeTab, sceneTitle, sectionId, onTabChange, onClose }) {
  return (
    <div className="interactivity-studio__topbar">
      <div className="interactivity-studio__title">
        <i className="material-icons interactivity-studio__title-icon">flash_on</i>
        {i18n.t("InteractivityStudio.title", { defaultValue: "Interactivity Studio" })}
      </div>
      <div className="interactivity-studio__tabs" role="tablist">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={activeTab === t.id ? "true" : "false"}
            className={`interactivity-studio__tab ${activeTab === t.id ? "interactivity-studio__tab--active" : ""}`}
            onClick={() => onTabChange(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <div className="interactivity-studio__scene-chip">
        <span className="interactivity-studio__scene-label">
          {i18n.t("InteractivityStudio.scene", { defaultValue: "Scene" })}:{" "}
        </span>
        <span className="interactivity-studio__scene-title">{sceneTitle}</span>
        {sectionId && <span className="interactivity-studio__scene-section"> · {sectionId}</span>}
      </div>
      <button
        type="button"
        className="interactivity-studio__close"
        aria-label={i18n.t("InteractivityStudio.close", { defaultValue: "Close" })}
        onClick={onClose}
      >
        <i className="material-icons">close</i>
      </button>
    </div>
  );
}
